export const getAriaDescribedBy = (error, name) =>
  error?.props?.isError && {
    'aria-describedby': `${name}-error`,
  };
